import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import XMLink from 'components/XMLink';

import styles from './SubNavMenuItem.module.scss';

const SubNavMenuItem = ({ intl, item, isActive, onClose }) => {
  const { id, name, to, selectorId } = item;
  const itemTitle = name || intl.formatMessage({ id });

  return (
    <li
      id={id}
      className={classnames(styles.item, {
        [styles.active]: isActive,
      })}
      title={itemTitle}
    >
      <XMLink
        to={to}
        id={selectorId}
        className={styles.link}
        onClick={onClose}
        data-testid={`subNavMenu_item subNavMenu_item-${id}`}
      >
        {itemTitle}
      </XMLink>
    </li>
  );
};

SubNavMenuItem.displayName = 'SubNavMenuItem';

SubNavMenuItem.propTypes = {
  intl: PropTypes.object.isRequired,
  item: PropTypes.shape().isRequired,
  isActive: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SubNavMenuItem;
